import { combineReducers } from "redux";
import { radiologistsListReducer } from "./reducers/radiologists-list-reducer";

export default combineReducers({
    radiologistsListReducer
});
